import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { Base } from '../../../components/Base';
import { appLayoutFooterStyles } from './AppLayoutFooter.styles';
export const AppLayoutFooter = forwardRef(function AppLayoutFooter(props, forwardedRef) {
    const { styles, sx, children, divider, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'AppLayoutFooter',
        styles: [appLayoutFooterStyles, styles],
    });
    return (_jsx(Base, { as: 'footer', ...other, sx: [globalStyles, combineStyles('host', divider && 'host$divider'), sx], ref: forwardedRef, children: children }));
});
